import wixWindow from 'wix-window';

let formFactor = wixWindow.formFactor

$w.onReady(function () {
	if (formFactor === "Mobile") {

		$w("#wordPressBox").hide();
		$w("#wixBox").style.borderWidth = "1px";

	}
	if (formFactor === "Desktop") {

		$w("#wordPressBG").hide();
		$w("#wixBG").hide();
		$w("#mobileBG").hide();
		$w("#closeBG").hide();
		$w("#whiteBoxWP").hide();
		$w("#whiteBoxWix").hide();
		$w("#wixBtn").disable(); 
		$w("#wordPressBtn").disable();
		$w("#CTA1Mobile").hide(); 
		$w("#CTA2Mobile").hide(); 
		$w("#CTA3Mobile").hide(); 
		$w("#CTA4Mobile").hide(); 
		$w("#CTA5Mobile").hide(); 
		$w("#CTA7Mobile").hide(); 
		$w("#CTA8Mobile").hide(); 
		$w("#CTA9Mobile").hide(); 
	}
});


export function wixBtn_click(event) {
	if (wixWindow.formFactor === "Mobile") {
		$w("#wordPressBox").hide();
		$w("#wordPressBG").hide();
		$w("#wixBox").show();
		$w("#wixBG").show();
		$w("#wixBox").style.borderWidth = "1px";
		$w("#wixBG").style.borderWidth = "1px";
		$w("#whiteBoxWP").hide();
		$w("#whiteBoxWix").show();
	}
}

export function wordPressBtn_click(event) {
	if (wixWindow.formFactor === "Mobile") {
		$w("#wordPressBox").show();
		$w("#wixBox").hide();
		$w("#wixBG").hide();
		$w("#wordPressBG").show();
		$w("#wordPressBox").style.borderWidth = "1px";
		$w("#wordPressBG").style.borderWidth = "1px";
		$w("#whiteBoxWP").show();
		$w("#whiteBoxWix").hide();
	}
}